/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { useEffect, useState } from "react";

export const BusinessIdEffect = ({ currentBusinessId, setCurrentBusinessId, user }) =>
    useEffect(() => {
        if (
            (!currentBusinessId || currentBusinessId === "") &&
            user &&
            user.BusinessDetails &&
            user.BusinessDetails.Code
        )
            setCurrentBusinessId(user.BusinessDetails.Code);
    }, [user]);

export const tabIndexEffect = ({
    currentBusinessId,
    setLoading,
    collection_tab_index,
    containerMode,
    dispatch,
    updateRecallListFromWeb,
    doSearch,
    searchFilter,
    sortBy,
    jobs_to_show,
    main_page,
}) =>
    useEffect(() => {
        if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache"))
            return;
        if (currentBusinessId !== "") {
            setLoading(true);
            if (collection_tab_index === 0) {
                dispatch(updateRecallListFromWeb(currentBusinessId, "", containerMode)).then(() => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        jobs_to_show,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
            } else if (collection_tab_index === 1) {
                dispatch(updateRecallListFromWeb(currentBusinessId, "ARCHIVED", containerMode)).then(() => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        jobs_to_show,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
            } else if (collection_tab_index === 2) {
                dispatch(updateRecallListFromWeb(currentBusinessId, "DELETED", containerMode)).then(() => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        jobs_to_show,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
            } else if (collection_tab_index === 3) {
                dispatch(updateRecallListFromWeb(currentBusinessId, "TEST", containerMode)).then(() => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        jobs_to_show,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
            }
        }
    }, [currentBusinessId, collection_tab_index]);

export const lastUserJobsEffect = ({ jobs_to_show, user_last_jobs_edited, sortBy, setJobsToShow, doSearch }) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        let hasJobs = false;
        if (jobs_to_show?.some)
            hasJobs = jobs_to_show?.some(function (job) {
                return job?.id === user_last_jobs_edited?.[0]?.id;
            });
        if (sortBy === "LASTEDITED" && !hasJobs) {
            // Add jobs to jobs to show
            if (user_last_jobs_edited?.length > 0) {
                setJobsToShow((prevJobsToShow) => [user_last_jobs_edited[0], ...prevJobsToShow]);
                doSearch(doSearch); //Just to refresh jobs
            }
        }
    }, [user_last_jobs_edited]);
};

export const sortByEffect = ({
    loading,
    doSearch,
    searchFilter,
    currentBusinessId,
    containerMode,
    sortBy,
    jobs_to_show,
    collection_tab_index,
    main_page,
}) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        if (loading) return;

        doSearch({
            terms: searchFilter,
            currentBusinessId,
            containerMode,
            sortBy,
            jobs_to_show,
            collection_tab_index,
            NumRecallItems: main_page.NumRecallItems,
        });
    }, [sortBy]);
};

export const searchEffect = ({
    setLoading,
    sortBy,
    searchFilter,
    delayedSearch,
    containerMode,
    currentBusinessId,
    collection_tab_index,
}) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        setLoading(true);
        delayedSearch({
            terms: searchFilter,
            currentBusinessId,
            containerMode,
            sortBy,
            collection_tab_index,
        });
    }, [searchFilter]);
};

export const containerModeEffect = ({
    containerMode,
    setLoading,
    API_BASE,
    fetchTimeout,
    dispatch,
    updateAPP,
    doSearch,
    searchFilter,
    jobs_to_show,
    currentBusinessId,
    sortBy,
    collection_tab_index,
    main_page,
    setIntialise,
}) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        if (containerMode === "") return;
        setLoading(true);
        let api_url = API_BASE() + "business" + (containerMode ? "/" + containerMode : "");

        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                dispatch(updateAPP("DistributorList", json)).then((e) => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        jobs_to_show,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
                setIntialise(true);
            })
            .catch((e) => {
                dispatch(updateAPP("DistributorList", []));
            });
    }, [containerMode]);
};

export const initialiseEffect = ({
    intialise,
    user,
    API_BASE,
    fetchTimeout,
    setIntialise,
    dispatch,
    updateAPP,
    loading,
    currentBusinessId,
    updateRecallListFromWeb,
}) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        if (window.debug && window.location.href.includes("static")) return;
        if (!intialise && user?.Role) {
            if (user?.Role >= 90) {
                let api_url = API_BASE() + "business/";
                fetchTimeout(api_url, {
                    method: "GET",
                })
                    .then((response) => response.json())
                    .then((json) => {
                        dispatch(updateAPP("DistributorList", json));
                        setIntialise(true);
                    })
                    .catch((e) => {
                        dispatch(updateAPP("DistributorList", []));
                    });
            }
        }
        if (!intialise && loading && currentBusinessId) {
            dispatch(updateRecallListFromWeb(currentBusinessId));
        }
    }, [intialise, user]);
};

export const mainPageEffect = ({
    containerMode,
    setLoading,
    dispatch,
    doSearch,
    searchFilter,
    jobs_to_show,
    currentBusinessId,
    sortBy,
    collection_tab_index,
    main_page,
    user,
    loading,
    updateRecallListFromWeb,
}) => {
    if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache")) {
        return;
    }
    useEffect(() => {
        if (main_page.page === "Recall" && user?.id && !loading) {
            setLoading(true);

            if (collection_tab_index === 0) {
                dispatch(
                    updateRecallListFromWeb(currentBusinessId ? currentBusinessId : user.BusinessDetails.Code)
                ).then(() => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        jobs_to_show,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
            } else if (collection_tab_index === 1) {
                dispatch(
                    updateRecallListFromWeb(
                        currentBusinessId ? currentBusinessId : user.BusinessDetails.Code,
                        "ARCHIVED"
                    )
                ).then(() => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        jobs_to_show,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
            } else if (collection_tab_index === 2) {
                dispatch(
                    updateRecallListFromWeb(
                        currentBusinessId ? currentBusinessId : user.BusinessDetails.Code,
                        "DELETED"
                    )
                ).then(() => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        jobs_to_show,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
            } else if (collection_tab_index === 3) {
                dispatch(
                    updateRecallListFromWeb(currentBusinessId ? currentBusinessId : user.BusinessDetails.Code, "TEST")
                ).then(() => {
                    doSearch({
                        terms: searchFilter,
                        currentBusinessId,
                        containerMode,
                        sortBy,
                        jobs_to_show,
                        collection_tab_index,
                        NumRecallItems: main_page.NumRecallItems,
                    });
                });
            }
        }
    }, [main_page]);
};

export const uploadFileEffect = ({
    API_BASE,
    fetchTimeout,
    currentBusinessId,
    user,
    updateRecallListFromWeb,
    readComplete,
    fileData,
    dispatch,
    setBackDrop,
    newDefaultJobState,
    config,
    setShowMessage,
    setDialogData,
}) =>
    useEffect(() => {
        if (readComplete && fileData.length > 0) {
            let filenames = [];
            for (let file of fileData)
                filenames.push(
                    <>
                        {file.name}
                        <br />
                    </>
                );

            setBackDrop(
                <>
                    Importing Files...
                    <br />
                    {filenames}
                </>
            );

            let api_url = API_BASE() + "JobImport/";
            fetchTimeout(
                api_url,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        imported_data: fileData,
                        job_template: newDefaultJobState(config, "", user),
                    }),
                },
                120000
            )
                .then((response) => response.json())
                .then((json) => {
                    if (json?.Error) {
                        throw json.Error;
                    }
                    setBackDrop(false);
                    setShowMessage({
                        type: "success",
                        message: json?.Success ? json?.Success : "Files Successfuly imported",
                    });
                    dispatch(
                        updateRecallListFromWeb(currentBusinessId ? currentBusinessId : user?.BusinessDetails?.Code)
                    );
                })
                .catch((e) => {
                    setBackDrop(false);
                    setDialogData({
                        title: "Error importing Job Files",
                        message: [<>{e?.message ? e.message : e}</>],
                        primaryActionText: "OK",
                        primaryAction: () => {},
                    });
                    dispatch(
                        updateRecallListFromWeb(currentBusinessId ? currentBusinessId : user?.BusinessDetails?.Code)
                    );
                });
        }
    }, [readComplete]);

export const useFetchJobPricesEffect = (API_BASE, fetchTimeout, businessCode, containerMode) => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!businessCode) {
            setError("Business code is missing.");
            setLoading(false);
            return;
        }

        setLoading(true);
        const endPoint = `${API_BASE()}job/prices/${businessCode}/`;

        fetchTimeout(endPoint, {
            method: "POST",
            body: JSON.stringify({
                Container: containerMode,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                const filteredData = data.filter((item) => Array.isArray(item.Jobs));
                const allJobs = filteredData.flatMap((item) => item.Jobs);

                const grouped = allJobs.reduce((acc, job) => {
                    let rawStatus = job.Status ? job.Status.toUpperCase() : "UNKNOWN";
                    const status = rawStatus === "NEW" || rawStatus === "LEAD" ? "LEAD" : rawStatus;
                    const { MaterialBase, TotalIncGST } = job;

                    if (!acc[status]) {
                        acc[status] = {
                            count: 0,
                            countNotPriced: 0,
                            TotalIncGSTSum: 0,
                            MaterialBaseSum: 0,
                            jobs: [],
                        };
                    }

                    acc[status].count += 1;

                    if (!TotalIncGST) {
                        acc[status].countNotPriced += 1;
                    } else {
                        acc[status].TotalIncGSTSum += TotalIncGST || 0;
                        acc[status].MaterialBaseSum += MaterialBase || 0;
                    }

                    acc[status].jobs.push(job);
                    return acc;
                }, {});

                const statusOrder = ["LEAD", "QUOTED", "ORDERED", "INVOICED"];

                const formattedTableData = Object.keys(grouped)
                    .map((statusKey) => ({
                        status: statusKey,
                        numberOfJobs: grouped[statusKey].count,
                        notPricedJobs: grouped[statusKey].countNotPriced,
                        TotalIncGSTSum: grouped[statusKey].TotalIncGSTSum,
                        MaterialBaseSum: grouped[statusKey].MaterialBaseSum,
                        jobs: grouped[statusKey].jobs,
                    }))
                    .sort((a, b) => {
                        const indexA = statusOrder.indexOf(a.status);
                        const indexB = statusOrder.indexOf(b.status);

                        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                        if (indexA !== -1) return -1;
                        if (indexB !== -1) return 1;

                        return 0;
                    });

                setTableData(formattedTableData);
                setLoading(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
    }, [businessCode, containerMode]);

    return {
        dashData: tableData,
        dashLoading: loading,
        dashError: error,
    };
};
